/* Notifications that are sent earlier come before those sent after it */
import hash from 'object-hash';

export const sortNotificationsOnSentTime = (notifications) =>
  notifications.sort((not1, not2) => {
    const timediff = not2.getTimestamp().diff(not1.getTimestamp());
    /* Could be the case that timestamp is the same, especially in the case of the test data.
     * Because the id's from the BO are not guaranteed to be unique, use a fallback */
    if (timediff === 0)
      return hash(JSON.stringify(not1)).localeCompare(hash(JSON.stringify(not2)));
    return timediff;
  });

export default class AbstractNotificationsCollection {
  constructor(notifications) {
    this.versionStamp = 0; // Keeps track if notifications have changed (read status), been added/removed/...
    this.versionStampQuantity = 0; // Only keeps track if notifications have been added
    this.versionStampUnread = 0; // Keeps track if unread notifications have been added
    this.notifications = notifications;
  }

  equalNotifications(key, toCompareWith) {
    const notifications = [...this[key]];
    sortNotificationsOnSentTime(toCompareWith);
    sortNotificationsOnSentTime(notifications);
    return (
      notifications.length === toCompareWith.length &&
      notifications.reduce(
        (areEqual, notification, index) =>
          areEqual && notification.equal(toCompareWith[index]),
        true
      )
    );
  }

  getNotifications() {
    return this.notifications;
  }

  hasEqualVersionStamp(oldVersionStamp) {
    return oldVersionStamp === this.versionStamp;
  }

  hasEqualQuantityVersionStamp(oldVersionStampQuantity) {
    return oldVersionStampQuantity === this.versionStampQuantity;
  }

  hasEqualUnreadVersionStamp(oldVersionStampUnread) {
    return oldVersionStampUnread === this.versionStampUnread;
  }

  hasUnreadNotifications() {
    return this.notifications.some((notification) => !notification.getIsRead());
  }

  hasNoNotifications() {
    return this.notifications.length === 0;
  }

  increaseVersionStamp() {
    return this.versionStamp++;
  }

  markAllAsRead() {
    this.notifications.forEach((notification) => notification.markAsRead());
    return this.increaseVersionStamp();
  }
}
